/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Run_Not_CancellableInputs */

const vi_error_irrigation_run_not_cancellable = /** @type {(inputs: Error_Irrigation_Run_Not_CancellableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên này đã bắt đầu hoặc đã xong nên không huỷ được. Muốn dừng thì bấm Tắt.`)
};

/**

* @param {Error_Irrigation_Run_Not_CancellableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_run_not_cancellable = /** @type {((inputs?: Error_Irrigation_Run_Not_CancellableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Run_Not_CancellableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_run_not_cancellable(inputs)
});